import { useSelector } from 'react-redux'

import { FEATURE_FLAGS } from '~featureFlags'
import { useFeatureGate } from '~hooks/access/useFeatureGate'
import { type RootState } from '~redux/rootReducer'
import { useGetEvaluationCategoriesQuery } from '~redux/slices/apiSlice'

import { useAISettings } from '../AISettingsScreen/AISettingsContext'

export const useCustomCategories = (): string[] | null => {
  const { enabled } = useFeatureGate(FEATURE_FLAGS.CUSTOM_AI_INTERACTION_CATEGORIES)
  const user = useSelector((state: RootState) => state?.auth.user)
  const { selectedOrganization } = useAISettings()
  const { data } = useGetEvaluationCategoriesQuery(
    { user_id: user?.id ?? '', organization_identity_id: selectedOrganization?.id ?? '' },
    { refetchOnMountOrArgChange: true, skip: !enabled || !user || !selectedOrganization },
  )
  return data?.is_custom ? data.categories.map((category) => category.name) : null
}
